<div (mouseenter)="this.dotComService.DisplaySubMenu('')">
    <div *ngIf="!submitSuccessful" class="container-fluid" style="max-width:80%">

        <img class="mt-5 mb-3" src="{{this.imagefilePath + '/Harrellslogo_GABW.jpg'}}" alt="Bill and Hold Agreement"
            style="width:200px">

        <div class="row" [innerHTML]="bhAgreement.HTMLTop">
        </div>

        <div class="row">
            <h6 class="col-md-2" style="border-bottom:1px solid black">Order Date</h6>
            <h6 class="col-md-2" style="border-bottom:1px solid black">Order #</h6>
            <h6 class="col-md-2" style="border-bottom:1px solid black">Product #</h6>
            <h6 class="col-md-4" style="border-bottom:1px solid black">Description</h6>
            <h6 class="col-md-2" style="border-bottom:1px solid black;padding-left:5%">Qty</h6>
        </div>

        <div class="row" *ngFor="let orders of bhAgreementData">
            <h6 class="col-md-2" style="border-bottom:1px solid grey">{{orders.DOCDATE}}</h6>
            <h6 class="col-md-2" style="border-bottom:1px solid grey">{{orders.SOPNUMBE}}</h6>
            <h6 class="col-md-2" style="border-bottom:1px solid grey">{{orders.ITEMNMBR}}</h6>
            <h6 class="col-md-4" style="border-bottom:1px solid grey">{{orders.ITEMDESC}}</h6>
            <h6 class="col-md-2" style="border-bottom:1px solid grey;padding-left:5%">{{orders.QUANTITY}}
                {{orders.UOFM}}
            </h6>
        </div>

        <div class="row" [innerHTML]="bhAgreement.HTMLBottom"></div>

        <div class="row">
            <input type="text" placeholder="Print Name" [(ngModel)]="printedName" (keyup)="CheckValid()"
                style="width:200px; margin-left:10px; margin-top:20px; margin-bottom: 0px;">
            <input type="text" placeholder="Title" [(ngModel)]="title" (keyup)="CheckValid()"
                style="width:200px; margin-left:20px;margin-top:20px; margin-bottom: 0px;">
        </div>
        <div class="row">
            <h6 style="display: inline-block; width:200px; margin-top: 0px; margin-bottom: 20px;">Print Name</h6>
            <h6 style="display: inline-block; width:200px; margin-top: 0px; margin-left:20px; margin-bottom: 20px;">
                Title</h6>
        </div>
        <div class="row">
            <input type="text" placeholder="Signature" [(ngModel)]="signedName" (keyup)="CheckValid()"
                style="font-family:'Brush Script MT'; font-size:x-large;width:200px; margin-left:10px; margin-bottom: 0px;">
            <input type="date" placeholder="Date" id="dateSignedId" (focus)="DefaultDate()" 
                (change)="CheckValid()" style="width:200px; margin-left:20px; margin-bottom: 0px;">
        </div>
        <div class="row">
            <h6 style="display: inline-block; width:200px; margin-top: 0px; margin-bottom: 20px;">Signature</h6>
            <h6 style="display: inline-block; width:200px; margin-top: 0px; margin-left:20px; margin-bottom: 20px;">Date
            </h6>
        </div>
        <div class="row">
            <h6 type="text" style="display: inline-block; width:200px; margin-bottom: 0px; font-weight:400">
                {{this.repID}}</h6>
            <h6 style="display: inline-block; width:200px; margin-bottom: 0px; margin-left:20px; font-weight:400">
                {{this.repName}}</h6>
            <h6 style="display: inline-block; width:200px; margin-bottom: 0px; margin-left:20px; font-weight:400">
                {{'Agreement #: ' + this.bhId}}</h6>
        </div>
        <div class="row">
            <h6 style="display: inline-block; width:200px; margin-top: 0px; margin-bottom: 20px;">Sales Rep Id</h6>
            <h6 style="display: inline-block; width:200px; margin-top: 0px; margin-left:20px; margin-bottom: 20px;">
                Sales Rep Name</h6>
        </div>
        <div class="row mb-5">
            <h6 style="display: inline-block; margin-bottom: 0px; font-weight:400">To electronically sign(preferred),
                please fill in the above and click 'Submit.'</h6>
            <div class="mt-2">
                <button class="whiteBackground blueText " (click)="SubmitBHAgreement()"
                    [disabled]="!this.validSignature"
                    [ngClass]="!this.validSignature ? 'greyDisabled': 'whiteBackground' "
                    style="width:200px; display:inline-block;font-size:20px;padding:8pt; text-decoration: none !important">SUBMIT</button>
            </div>
        </div>
        <div class="row" [innerHTML]="bhAgreement.HTMLFooter"></div>
    </div>
    <div *ngIf="submitSuccessful" class="container-fluid" style="min-height:70vh;max-width:80%">
        <div class="row">
            <div class="col-sm-12" style="text-align: center;">
                <H3 style="margin-top:30vh">Submitted Successfully.  Thank you!</H3>
            </div>
        </div>
</div>